'use strict';

require('fast-text-encoding');

module.exports = {
  encode: function encode(string) {
    return new TextEncoder().encode(string);
  },
  decode: function decode(buffer) {
    return new TextDecoder().decode(buffer);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-textencoder/browser.js
// module id = /WH9
// module chunks = 0